const { adminCall } = require("./_utils");

module.exports = {
  create: data => adminCall("member.create", data),
  modify: data => adminCall("member.modify", data),
  remove: uid => adminCall("member.remove", {uid}),
  existEmail: (email) => adminCall("member.existEmail", {email}),
  changeEmail: ({uid, email, password}) => adminCall("member.changeEmail", {
    uid,
    email,
    password
  }),
}
